import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Product } from '../_models/product';
import { map } from 'rxjs/operators';
import { Batch } from '../_models/batch-number';
import { BehaviorSubject } from 'rxjs';
import { Stats } from './../_models/stats';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  public updateProductData = new BehaviorSubject<Product>(null);
  public copyProductData = new BehaviorSubject<Product>(null);

  constructor(private http: HttpClient) {}

  getAllProducts() {
    return this.http.get<Product[]>(`${environment.apiUrl}/api/products`).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  getOne(id: number) {
    return this.http.get<Product>(`${environment.apiUrl}/api/products/${id}`);
  }

  getBatchNumber() {
    return this.http
      .get<Batch>(`${environment.apiUrl}/api/products/create`)
      .pipe(
        map((batchNumber) => {
          return batchNumber;
        })
      );
  }

  deleteProduct(productId: number) {
    return this.http.delete(`${environment.apiUrl}/api/products/${productId}`);
  }

  deleteDocument(documentId: number) {
    return this.http.delete(
      `${environment.apiUrl}/api/product-technical-documentations/${documentId}`
    );
  }

  updateProduct(product: any, productId: number) {
    return this.http.post<Product>(
      `${environment.apiUrl}/api/products/${productId}`,
      product
    );
  }

  addProduct(product: any) {
    return this.http.post<Product[]>(
      `${environment.apiUrl}/api/products`,
      product
    );
  }

  getProductStats(productId: number, pageIndex: number) {
    return this.http
      .get<Stats>(
        `${environment.apiUrl}/api/products/${productId}/stats?page=${pageIndex}`
      )
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }

  /**
   * IMPROVED NIP
   */
  getAll(pageIndex: number, perPage: number, queryParams) {
    return this.http.get<any>(
      `${environment.apiUrl}/api/products?page=${pageIndex}&per_page=${perPage}&${queryParams}`
    );
  }

  delete(nipId: number) {
    return this.http.delete(`${environment.apiUrl}/api/products/${nipId}`);
  }

  getOneProduct(nipId: number) {
    return this.http.get<any[]>(`${environment.apiUrl}/api/products/${nipId}`);
  }
}
